import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import GoogleLogin from 'react-google-login';

import Config from 'configuration';

import { googleLogin } from 'actions/user';
import google from 'assets/img/google.png';

import redirectAfterLogin from './redirectAfterLogin';

export class GoogleLoginContainer extends Component {
  handleSuccess = async (response) => {
    const { dispatch, history } = this.props;
    // NOTE: this is a Google-provided access token, not our JWT
    const { access_token: googleAccessToken } = response.getAuthResponse();
    const data = await dispatch(googleLogin(googleAccessToken));
    // Send the user where they need to go next
    redirectAfterLogin(history, data);
  }

  handleFailure = (err) => {
    console.error('google error: ', err);
  }

  render = () => {
    const { label } = this.props;
    const { googleId } = Config;

    return (
      <GoogleLogin
        clientId={googleId}
        buttonText={(
          <span>
            <img src={google} alt="Google" />
            {' '}
            {label}
          </span>
        )}
        className="button button--google"
        autoLoad={false}
        onSuccess={this.handleSuccess}
        onFailure={this.handleFailure}
      />
    );
  }
}

GoogleLoginContainer.propTypes = {
  label: PropTypes.string.isRequired,
};

export default withRouter(connect()(GoogleLoginContainer));